import { create } from 'zustand';

interface TableStore {
    removeIdArray: string[];
    setRemoveIdArray: (obj: string[]) => void;

    showMenu: boolean;
    setShowMenu: (obj: boolean) => void;

    continuousMenu: boolean;
    setContinuousMenu: (obj: boolean) => void;

}

const useTableStore = create<TableStore>((set) => ({
    removeIdArray: [],
    setRemoveIdArray: (obj) => set({ removeIdArray: obj }),

    showMenu: false,
    setShowMenu: (obj) => set({ showMenu: obj }),

    continuousMenu: false,
    setContinuousMenu: (obj) => set({ continuousMenu: obj }),

}));

export default useTableStore;
